module.exports = __webpack_public_path__ + "static/media/imagenVeryDarkBrown.60250ab4.png";